import React from 'react';
import { InboxChat } from '@/components/screens/dashboard/inbox/InboxChat';
import { GenericCard } from '../containers';
import clsx from 'clsx';

interface LayoutInboxProps {
	children: React.ReactNode;
	showChatAIOnly?: boolean;
}

export const LayoutInbox: React.FC<LayoutInboxProps> = ({
	children,
	showChatAIOnly = false,
}) => {
	return (
		<>
			<div className="flex gap-[10px] h-full">
				{!showChatAIOnly && (
					<div className="w-full xl:w-2/3 2xl:w-3/4 ">
						<GenericCard className="md:space-y-4 !min-h-fit md:!h-[78vh] 3xl:!h[80vh] relative">
							{children}
						</GenericCard>
					</div>
				)}
				<div
					className={clsx(
						'xl:w-1/3 2xl:w-1/4 flex-1',
						showChatAIOnly ? 'w-full max-w-5xl mx-auto' : 'hidden xl:block'
					)}
				>
					<InboxChat />
				</div>
			</div>
		</>
	);
};
